// src/components/MemoDocumenti.jsx
import React from "react";
import { CalendarDays, ChevronRight } from "lucide-react";

const colorMap = {
    red: "text-[#F44346]",
    orange: "text-[#FA8216]",
    slate: "text-[#454545]",
};

export default function MemoDocumenti({ items = [] }) {
    return (
        <div className="h-full flex flex-col">
            <div className="space-y-3">
                {items.map((it, idx) => (
                    <button
                        key={idx}
                        type="button"
                        onClick={it.onClick}
                        className={[
                            "w-full h-10",
                            "flex items-center justify-between",
                            "px-4",
                            "bg-white border border-slate-200",
                            "shadow-[0px_20px_25px_-5px_rgba(0,0,0,0.1),0px_2px_4px_rgba(0,0,0,0.1)]",
                            "rounded-[20px]",
                            "hover:bg-slate-50 transition",
                            "text-left",
                        ].join(" ")}
                    >
                        <span className="flex items-center gap-2 min-w-0">
                            <CalendarDays size={16} className={colorMap[it.color] || colorMap.slate} />
                            <span className="text-[16px] text-[#454545] truncate">{it.text}</span>
                        </span>
                        <ChevronRight size={18} className="text-[#454545] shrink-0" />
                    </button>
                ))}
            </div>
        </div>
    );
}